// Ficheiro único de configuração.
// O barbeiro só precisa de editar este ficheiro para alterar todos os dados do site.

export const siteConfig = {
    brand: {
        name: "Barbearia18",
        tagline: "Barbeiro em Sintra",
        monogram: "B18",
    },

    hero: {
        eyebrow: "Barbearia · Sintra",
        title: "Um corte afiado.",
        titleAccent: "Uma tradição impecável.",
        subtitle:
            "Reserva o teu horário em menos de um minuto. Sem app. Sem conta. Sem complicações.",
    },

    about: {
        title: "Navalha, pente e um bom café.",
        body: "Uma barbearia de bairro em Sintra, onde cada cliente é recebido como um velho amigo. Cortes clássicos, barbas tratadas e o tempo certo para te entregar a melhor versão de ti.",
        years: "4.8",
        yearsLabel: "★ no Google",
        clients: "52+",
        clientsLabel: "avaliações",
    },

    services: [
        {
            id: "corte-classico",
            name: "Corte Clássico",
            description: "Tesoura, máquina e acabamento na navalha.",
            duration: 30,
            price: 12,
        },
        {
            id: "corte-moderno",
            name: "Corte Moderno",
            description: "Degradê, skin fade ou estilo à tua escolha.",
            duration: 40,
            price: 14,
        },
        {
            id: "barba",
            name: "Barba",
            description: "Desenho, aparar e acabamento cuidado.",
            duration: 20,
            price: 10,
        },
        {
            id: "corte-barba",
            name: "Corte + Barba",
            description: "O pacote completo. Sai como novo.",
            duration: 50,
            price: 20,
        },
        {
            id: "corte-crianca",
            name: "Corte Criança (até 10 anos)",
            description: "Mimo especial para os mais pequenos.",
            duration: 30,
            price: 10,
        },
    ],

    gallery: [
        {
            url: "https://images.pexels.com/photos/4351726/pexels-photo-4351726.jpeg",
            alt: "Close-up de corte masculino",
        },
        {
            url: "https://images.pexels.com/photos/7781848/pexels-photo-7781848.jpeg",
            alt: "Corte perfil",
        },
        {
            url: "https://images.pexels.com/photos/16407082/pexels-photo-16407082.jpeg",
            alt: "Ferramentas de barbeiro",
        },
        {
            url: "https://images.unsplash.com/photo-1622287162716-f311baa1a2b8?w=1200",
            alt: "Ambiente da barbearia",
        },
        {
            url: "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=1200",
            alt: "Detalhe navalha",
        },
    ],

    testimonials: {
        sectionTitle: "O que dizem",
        sectionSubtitle: "de quem se senta na cadeira.",
        items: [
            {
                name: "João Marques",
                quote: "Atendimento de excelência. O melhor degradê que já fiz e o ambiente é incrível. Já não vou a outro sítio.",
                rating: 5,
                source: "Google",
            },
            {
                name: "Pedro Silva",
                quote: "Profissionalismo do início ao fim. A barba ficou mesmo como pedi. Recomendo de olhos fechados.",
                rating: 5,
                source: "Google",
            },
            {
                name: "Tiago Almeida",
                quote: "Bom atendimento, excelente preço e mãos cheias para cortar cabelo. Saio sempre satisfeito.",
                rating: 5,
                source: "Google",
            },
            {
                name: "Ricardo Sousa",
                quote: "Conheci a Barbearia18 por recomendação e foi a melhor decisão. Cuidado nos detalhes e ótima conversa.",
                rating: 5,
                source: "Google",
            },
        ],
    },

    contact: {
        whatsapp: "+351926062884", // sem espaços; usado em wa.me
        whatsappDisplay: "+351 926 062 884",
        phone: "926 062 884",
        email: "",
        address: "R. Padre Amaro Teixeira de Azevedo, 2710-633 Sintra",
        mapsEmbed:
            "https://maps.google.com/maps?q=Barbearia18+R.+Padre+Amaro+Teixeira+de+Azevedo+Sintra&output=embed",
        instagram: "https://www.instagram.com/barbearia_18_/",
        instagramHandle: "@barbearia_18_",
    },

    hours: [
        { days: "Terça — Sexta", time: "09:00 — 20:00" },
        { days: "Sábado", time: "09:00 — 18:00" },
        { days: "Domingo & Segunda", time: "Fechado" },
    ],

    // Substitui "exemplo-barbearia" pelo teu username Cal.com (cal.com/exemplo-barbearia)
    calcom: {
        username: "exemplo-barbearia",
        // Se no Cal.com criares event types com estes slugs, a reserva abre directamente
        // no serviço certo. Caso contrário, abre o calendário geral (funciona na mesma).
        // eventTypeMap: { "corte-classico": "corte-classico", ... }
    },
};
